import { APIConstants } from '../../constants/api';
import { apiService } from '../../services';
import { AxiosResponse } from 'axios';
import { StatusConfigData } from './types';

class StatusConfigService {
  public static getStatusConfig = (): Promise<StatusConfigData> => {
    return apiService
      .get<AxiosResponse>({
        path: APIConstants.STATUS_CONFIG.GET_STATUS_CONFIG,
      })
      .then((response) => {
        const {
          data: { data },
        } = response;
        return { approvalStatus: data };
      })
      .catch((error) => {
        throw error;
      });
  };
}

export default StatusConfigService;
